/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";

/** @module core/modules/object-utils/rename-property */

/**
 * @description Renames the indicated property inside the passed object.
 * @param {Object<string,*>} obj - Input object.
 * @param {string} oldPropertyName - Property to be renamed.
 * @param {string} newPropertyName - New name for property.
 * @returns {boolean} Result.
 */
function renameProperty(obj, oldPropertyName, newPropertyName) {
  if (typeof obj[oldPropertyName] === 'undefined' || typeof obj[newPropertyName] !== 'undefined') {
    return false;
  }

  _Object$defineProperty(obj, newPropertyName, _Object$getOwnPropertyDescriptor(obj, oldPropertyName));

  delete obj[oldPropertyName];
  return true;
}

export { renameProperty };